import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import './styles.sass';

const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
        }
    },
    move: {
        '&&': {
            marginTop: -5
        }
    }
});

const IngredientBox = ({ index, title, amount, unit }) => {
    const classes = useStyles();

    return (
        <div className="ingredient-container">
            <div className="index-wrapper">
                <Typography variant='h6' className={classes.text}>{index + 1}</Typography>
            </div>
            <div>
                <Typography variant='h6' className={classes.text}>{title}</Typography>
                <Typography
                    variant='subtitle1'
                    className={clsx(classes.text, classes.move)}
                >
                    {amount} {unit}
                </Typography>
            </div>
        </div>
    )
}

export default IngredientBox;